/**
 * Created by Moment on 2017/2/21.
 */

// CYZS退款状态常量
export const CYZSRefundStatusConst = {
  /**
   * 未处理
   */
  NOT_PROCESS: 1,

  /**
   * 已申请
   */
  WAIT_PROCESS: 2,

  /**
   * 同意退款
   */
  ACCEPT: 4,

  /**
   * 已给用户地址
   */
  HAS_SENT_ADDRESS: 8,

  /**
   * 等待收货（已在第三方平台设置物流单号）
   */
  WAIT_RECEIVE: 16,

  /**
   * 退款完成
   */
  REFUND_COMPLETE: 32,

  /**
   * 取消退款
   */
  REFUND_CANCELED: 64,

  /**
   * 驳回退款
   */
  REFUND_REJECTED: 128,

  /**
   * 商家不同意
   */
  BUSINESS_NOT_ACCEPT: 256,

  /**
   * 已申请并已给用户地址 (已弃用)
   */
  // WAIT_PROCESS_AND_HAS_SENT_ADDRESS:512,

  /**
   * 已填运单号
   */
  HAS_FILL_EXPRESS_NUMBER: 1024
}

// CYZS退款状态值对应的字面量对象
export const CYZSRefundStatusList = {
  /**
   * 未处理
   */
  '1': {
    text: '未处理',
    status: 1
  },

  /**
   * 已申请
   */
  '2': {
    text: '已申请',
    status: 2
  },

  /**
   * 同意退款
   */
  '4': {
    text: '同意退款',
    status: 4
  },
  /**
   * 已给用户地址
   */
  '8': {
    text: '已给用户地址',
    status: 8
  },
  /**
   * 等待收货
   */
  '16': {
    text: '等待收货',
    status: 16
  },
  /**
   * 退款完成
   */
  '32': {
    text: '退款完成',
    status: 32
  },

  /**
   * 退款取消
   */
  '64': {
    text: '退款取消',
    status: 64
  },
  /**
   * 驳回退款
   */
  '128': {
    text: '驳回退款',
    status: 128
  },
  /**
   * 商家不同意
   */
  '256': {
    text: '商家不同意',
    status: 256
  },
  /**
   * 已申请第三方退款并且已给用户退货地址(已弃用)
   */
  // '512':{
  //   text:'已申请&已给地址',
  //   status:512
  // },
  /**
   * 待填写运单号
   */
  '1024':{
    text:'待填写运单号',
    status:1024
  }
}
